import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import CustomDropdown from '@components/CustomDropdown';
import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import { fetchSupplierDetails } from '@store/supplier/action';

import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

const SourcingTeam = ({ supplierInfo, isAdd, onSetAdd }) => {
	const [userList, setUserList] = useState([]);
	const [show, setShow] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [partnerShipOwner, setPartnerShipOwner] = useState({});
	const [relationshipManager, setRelationshipManager] = useState({});
	const { id } = useParams();
	const dispatch = useDispatch();

	useEffect(() => {
		setShow(isAdd);
	}, [isAdd]);

	useEffect(() => {
		if (supplierInfo?.partnershipOwner) {
			setPartnerShipOwner({
				key: supplierInfo?.partnershipOwner?.id,
				value: supplierInfo?.partnershipOwner?.name,
				email: supplierInfo?.partnershipOwner?.email
			});
		}
		if (supplierInfo?.relationshipManager) {
			setRelationshipManager({
				key: supplierInfo?.relationshipManager?.id,
				value: supplierInfo?.relationshipManager?.name,
				email: supplierInfo?.relationshipManager?.email
			});
		}
	}, [supplierInfo]);

	const fetchUserList = async () => {
		await ApiClient.GET('getProjectUserSuggestions', '?isNitexUser=true&size=1000')
			.then(({ data }) => {
				if (data) {
					const result = data?.map((item) => {
						return {
							key: item.id,
							value: item.name,
							email: item.email
						};
					});
					setUserList(result);
				}
			})
			.catch(({ response }) => {
				toastError(response.data.message);
			});
	};

	useEffect(() => {
		fetchUserList();
	}, []);

	const onItemClick = (item) => {
		if (item?.title === 'Partnership Owner') {
			setPartnerShipOwner(item);
		}
		if (item?.title === 'Key relationship manager') {
			setRelationshipManager(item);
		}
	};

	const handleClose = () => {
		onSetAdd();
	};

	const handleSubmit = async () => {
		setIsLoading(true);
		let postData = {
			partnershipOwnerId: partnerShipOwner.key,
			relationshipManagerId: relationshipManager.key
		};
		await ApiClient.PUT(`${BASE_URL}/supplier/${id}/account-owner-poc`, postData, '', true)
			.then(({ data }) => {
				dispatch(fetchSupplierDetails(id));
				toastSuccess(data.message);
				setIsLoading(false);
				handleClose();
			})
			.catch(({ response }) => {
				setIsLoading(false);
				toastError(response.data.message);
			});
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div className="row">
				{/* <div className="one-half">
					<img
						src={`${process.env.PUBLIC_URL}/icons/edit-supplier.svg`}
						alt="edit"
						className="edit-icon"
						onClick={onEditClick}
					/>
				</div> */}
				<div className="col-sm-6 col-md-6 padding-col">
					<div className="sourcing-team d-flex align-items-center">
						<div className="img">
							{!supplierInfo?.partnershipOwner?.profilePicDocument?.docUrl ? (
								<span className="regular-16 white rounded-circle">
									{supplierInfo?.partnershipOwner?.name?.charAt(0).toUpperCase()}
								</span>
							) : (
								<img
									src={supplierInfo?.partnershipOwner?.profilePicDocument?.docUrl}
									alt="user"
								/>
							)}
						</div>
						<div className="sourcing-content">
							<h3 className="gray_dark_01 regular-14 weight-600">Partnership owner</h3>
							<p className="gray_dark_02 regular-14">
								{supplierInfo?.partnershipOwner?.name}{' '}
								{supplierInfo?.partnershipOwner?.designation
									? ` (${supplierInfo?.partnershipOwner?.designation})`
									: ''}
							</p>
						</div>
					</div>
				</div>
				<div className="col-sm-6 col-md-6 padding-col">
					<div className="sourcing-team d-flex align-items-center">
						<div className="img">
							{!supplierInfo?.relationshipManager?.profilePicDocument?.docUrl ? (
								<span className="regular-16 white rounded-circle">
									{supplierInfo?.relationshipManager?.name?.charAt(0).toUpperCase()}
								</span>
							) : (
								<img
									src={supplierInfo?.relationshipManager?.profilePicDocument?.docUrl}
									alt="user"
								/>
							)}
						</div>
						<div className="sourcing-content">
							<h3 className="gray_dark_01 regular-14 weight-600">Key Relationship Manager</h3>
							<p className="gray_dark_02 regular-14">
								{supplierInfo?.relationshipManager?.name}
								{supplierInfo?.relationshipManager?.designation
									? ` (${supplierInfo?.relationshipManager?.designation})`
									: ''}
							</p>
						</div>
					</div>
				</div>
			</div>
			{/* <div className="one-half">
				<img src={`${process.env.PUBLIC_URL}/icons/edit-supplier.svg`} alt="edit" className="edit-icon" onClick={onEditClick} />
			</div> */}
			<Modal
				className="production-capacity-popup account-owner-poc-popup"
				show={show}
				onHide={handleClose}
				centered
				backdrop="static"
			>
				<div className="common-popup">
					<Modal.Header closeButton>
						<h3 className="semibold-16 mb-0">Account owner & POC</h3>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body">
							<div className="form-group">
								<label>Partnership owner</label>
								<CustomDropdown
									type="addItem"
									title={'Partnership Owner'}
									onItemClick={onItemClick}
									items={userList}
									selectedItem={partnerShipOwner.value}
								/>
							</div>
							<div className="form-group mb-0">
								<label>Key relationship manager</label>
								<CustomDropdown
									type="addItem"
									title={'Key relationship manager'}
									onItemClick={onItemClick}
									items={userList}
									selectedItem={relationshipManager.value}
								/>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button className="button outline size32" onClick={handleClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={handleSubmit} disabled={isLoading}>
							Submit
						</button>
					</Modal.Footer>
				</div>
			</Modal>
		</LoaderComponent>
	);
};

export default SourcingTeam;
